module.exports = __webpack_public_path__ + "static/media/text-nav2.03b1a649.svg";